import { useFormatter } from 'next-intl';
import { currentTimeZone } from '@/shared/utils/time/timezone';

/**
 * Formats the date of a meeting in the format "Wed, Jan 1, 2025"
 *
 * @see [Design system](https://www.figma.com/design/ulUeUVSNgLMAYaeH0nJxCI/Den-Components?node-id=4753-3935&m=dev)
 */
export function useFormatMonthDayYear({ showWeekday = true } = {}) {
  const format = useFormatter();
  return (date: Date) =>
    format.dateTime(date, {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      weekday: showWeekday ? 'short' : undefined,
      timeZone: currentTimeZone || undefined,
    });
}
